module.exports = __webpack_public_path__ + "static/media/appDemo.7723ed95.png";